<template>
    <div class="equipmentRate">
        <div class="e_title">
            {{ title }}
        </div>
        <el-carousel indicator-position="outside" @change="carouselActive" :initial-index="activeIndex"  :autoplay="autoplay" :interval="5000">
            <el-carousel-item v-for="item in quotaData" :key="item">
                <div class="e_show_module">
                    <div class="runPoints" v-for="(cItem,cIndex) in item.list" :key="cItem.type" @click="openDialog(cItem)">
                        <div class="circular" v-if="cIndex === item.list.length - 1"></div>
                        <runPoints :chart-data="cItem.data"></runPoints>
                        <div class="cir-font">
                            <span class="f-num HuXiaoBo">{{ cItem.data.value }}</span>
                            <span>%</span>
                        </div>
                        <div class="show_font HuXiaoBo" v-if="cIndex !== item.list.length - 1">
                            {{cItem.type}}
                        </div>
                        <div class="show_date" v-if="cIndex !== item.list.length - 1">
                            {{cItem.time}}
                        </div>
                        <div class="now_date" v-if="cIndex === item.list.length - 1">
                            {{cItem.time}}
                        </div>
                    </div>
                </div>

            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import runPoints from './runPoints';
import { dateFormat } from "utils/tools";
import jsonData from '/public/static/js/json/operatieCenter.json';
export default {
    name: 'equipmentRate',
    title: '设备率',
    components: {
        runPoints
    },
    data () {
        return {
            title: '设备在线率',
            quotaData: [
                {
                    "name": "设备在线率",
                    "list": [
                        {
                            "data": {
                                "value": 0,
                                "color1": "#a2f5a1",
                                "color2": "#8ee2ef"
                            },
                            "type": "保障前",
                            "time": "--"
                        },
                        {
                            "data": {
                                "value": 0,
                                "color1": "#03c3fe",
                                "color2": "#0178ff"
                            },
                            "type": "保障后",
                            "time": "---"
                        },
                        {
                            "data": {
                                "value": 0,
                                "color1": "#06cbff",
                                "color2": "#9ff9fc"
                            },
                            "type": "当前",
                            "time": "--"
                        }
                    ]
                },
                {
                    "name": "生产治理同步率",
                    "list": [
                        {
                            "data": {
                                "value": 0,
                                "color1": "#a2f5a1",
                                "color2": "#8ee2ef"
                            },
                            "type": "保障前",
                            "time": "--"
                        },
                        {
                            "data": {
                                "value": 0,
                                "color1": "#03c3fe",
                                "color2": "#0178ff"
                            },
                            "type": "保障后",
                            "time": "--"
                        },
                        {
                            "data": {
                                "value": 0,
                                "color1": "#06cbff",
                                "color2": "#9ff9fc"
                            },
                            "type": "当前",
                            "time": "--"
                        }
                    ]
                },
                {
                    "name": "高频高幅",
                    "list": [
                        {
                            "data": {
                                "value": 0,
                                "color1": "#a2f5a1",
                                "color2": "#8ee2ef"
                            },
                            "type": "保障前",
                            "time": "--"
                        },
                        {
                            "data": {
                                "value": 0,
                                "color1": "#03c3fe",
                                "color2": "#0178ff"
                            },
                            "type": "保障后",
                            "time": "--"
                        },
                        {
                            "data": {
                                "value": 0,
                                "color1": "#06cbff",
                                "color2": "#9ff9fc"
                            },
                            "type": "当前",
                            "time": "--"
                        }
                    ]
                }
            ],
            autoplay: true,
            showData: [],
            activeIndex: 0,
        }
    },
    computed: {
        dialogValue() {
            return this.$store.state.operationCenterDialog
        }
    },
    watch: {
        dialogValue: {
            handler(newVal, oldVal) {
                console.log("ssfs", newVal, newVal.state, newVal.params.type)
                if (newVal.state && (newVal.params.type == '生产治理同步率' || newVal.params.type == '高频高幅' || newVal.params.type == '设备在线率')) {
                    this.autoplay = false
                    console.log('autoplay', this.autoplay)
                } else {
                    this.autoplay = true
                    console.log('autoplay1', this.autoplay)
                }
            },
            deep: true,
        }
    },
    created () {
        let p1 = this.getSafeguardRate(1)
        let p2 = this.getSafeguardRate(2)
        let p3 = this.getSafeguardRate(3)
        Promise.all([p1, p2, p3]).then((result) => {
            console.log("9999", result)
            for (let i = 0; i < result.length; i++) {
                if (i == 0) {
                    this.quotaData[2] = { name: '高频高幅', list: result[i] }
                } if (i == 1) {
                    this.quotaData[1] = { name: '生产治理同步率', list: result[i] }
                } if (i == 2) {
                    this.quotaData[0] = { name: '设备在线率', list: result[i] }
                    
                }

            }
            console.log(888, this.quotaData)
        }).catch((error) => {
            console.log(error)      // 失败了，打出 '失败'
        })
    },
    mounted () {
        // this.quotaData = jsonData.quotaData;
        // this.getShowData();
    },
    methods: {
        // 查询保障前后数据信息
        getSafeguardRate (id) {
            return new Promise((resolve, reject) => {
                let url =
                    CONFIG.requestName + this.$apiOpt.safeguardRate;
                this.$apiUtils
                    .get(url, {
                        customerId: this.$store.state.customerId,
                        type: id
                    })
                    .then(data => {
                        let arr = []
                        for (let key in data) {
                            if (key == 'safeguardBefore') {
                                arr[0] =
                                {
                                    data: {
                                        value: data[key].statisticsRate, "color1": "#a2f5a1",
                                        "color2": "#8ee2ef"
                                    },
                                    time: data[key].statisticsTime,
                                    type: '保障前',
                                    safeguardTime: [dateFormat(
                                  "YYYY-mm-dd HH:MM:SS",data.safeguardTime - 30 * 24 * 60 * 60 * 1000), dateFormat(
                                  "YYYY-mm-dd HH:MM:SS",data.safeguardTime)]
                                }
                            } if (key == 'safeguardAfter') {
                                arr[1] =
                                {
                                    data: {
                                        value: data[key].statisticsRate, "color1": "#03c3fe",
                                        "color2": "#0178ff"
                                    },
                                    time: data[key].statisticsTime,
                                    type: '保障后',
                                    safeguardTime: [dateFormat(
                                  "YYYY-mm-dd HH:MM:SS",data.safeguardTime), dateFormat(
                                  "YYYY-mm-dd HH:MM:SS",data.safeguardTime + 30 * 24 * 60 * 60 * 1000)]
                                }
                            } if (key == 'current') {
                                arr[2] =
                                {
                                    data: {
                                        value: data[key].statisticsRate, "color1": "#06cbff",
                                        "color2": "#9ff9fc"
                                    },
                                    time: data[key].statisticsTime,
                                    type: '当前',
                                    safeguardTime: [dateFormat(
                                  "YYYY-mm-dd HH:MM:SS",new Date(new Date().setHours(0, 0, 0, 0))), dateFormat(
                                  "YYYY-mm-dd HH:MM:SS",new Date())]
                                }
                            }
                        }
                        // this.showData = arr
                        console.log('showData', this.showData)
                        resolve(arr)
                    });

            })

        },

        carouselActive (val) {
            console.log('val', val)
            this.title = this.quotaData[val].name;
        },
        getShowData () {
            this.showData = this.quotaData[this.activeIndex].list;
            console.log("showData", this.showData)
            this.title = this.quotaData[this.activeIndex].name;
        },
        openDialog (item) {
          console.log('item', item)
            this.$store.commit("upDateOperationCenterDialog", { state: true, params: { type: this.title, value: item.data, time: item.safeguardTime } });
        }
    }
}
</script>

<style lang="scss" scoped>
.equipmentRate {
    padding-top: 10px;
    padding-left: 10px;
    transition: none 0s ease 0s;
    .e_title {
        font-size: 30px;
        color: #63f2ef;
        padding-left: 20px;
        font-weight: 600;
    }
    .e_show_module {
        display: flex;
        margin-top: -20px;
        .runPoints {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            cursor: pointer;
            .circular {
                position: absolute;
                top: 10%;
                width: 120px;
                height: 120px;
                border-radius: 50%;
                border: 2px dashed #82afc3;
            }
            .show_font {
                font-size: 18px;
                margin-top: -10px;
            }
            .cir-font {
                position: absolute;
                top: 34%;
                left: 50%;
                transform: translateX(-50%);
                .f-num {
                    font-size: 28px;
                }
            }
        }
        .show_date {
            color: #6dbeee;
        }
        .now_date {
            color: #48def3;
            font-size: 24px;
        }
    }
    .e_button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 150px;
        height: 20px;
        margin: 0 auto;
        .button_item {
            width: 30px;
            height: 5px;
            border-radius: 10px;
            background: #bcc8e6;
            cursor: pointer;
            margin-right: 10px;
        }
        .active {
            background: #5ec7f2;
        }
    }
}
</style>

<style lang="scss">
.equipmentRate {
    .el-carousel__container {
        height: 180px;
    }
    .el-carousel__indicator--horizontal .carousel__button {
        width: 26px;
        height: 4px;
        background: #a9a9a9;
        border-radius: 2px 2px 2px 2px;
    }
    .el-carousel__indicators--outside button {
        width: 26px;
        height: 4px;
        background: #a9a9a9;
        border-radius: 2px 2px 2px 2px;
    }
    .el-carousel__indicator.is-active button {
        background: linear-gradient(90deg, #00a3ff 0%, #b2fefc 100%);
    }
}
</style>
